import * as z from 'zod';
import { DEFAULT_PAGE_SIZE, FIRST_PAGE } from '@noor/config';
import { courierActivitySchema, courierStatusFilterSchema } from './schema';

/**
 * URL search-param schema for the couriers list. Table state lives in the URL
 * (status tab, filters, sort, page) — the legacy page kept status/sorting in
 * component state and stripped them from the URL, which made refresh and
 * deep links lose them; here they are first-class params.
 *
 * Coerced + caught (never strict): the router JSON-parses search params, so a
 * bare numeric link (`?equipment=3`) arrives as a number, and a stale value
 * must fall back to the default instead of crashing route validation.
 */
const optionalString = z.coerce.string().optional().catch(undefined);

export const courierListSearchSchema = z.object({
  status: courierStatusFilterSchema.catch('ALL').default('ALL'),
  search: optionalString,
  equipment: optionalString,
  activity: courierActivitySchema.optional().catch(undefined),
  /** Legacy deep-link params that no control sets but the filter still honors. */
  group_id: optionalString,
  rating: optionalString,
  /** Orders window (`YYYY-MM-DD`) driving the order aggregates. */
  start_date: optionalString,
  end_date: optionalString,
  /** Range filters (the legacy per-column FilterDialog, folded into one modal). */
  balance_from: optionalString,
  balance_till: optionalString,
  scooter_balance_from: optionalString,
  scooter_balance_till: optionalString,
  rating_from: optionalString,
  rating_till: optionalString,
  orders_count_from: optionalString,
  orders_count_till: optionalString,
  /** Single active sort, `"<field>:<1|2>"` (1 = ascending wire `true`). */
  sort: optionalString,
  page: z.coerce.number().int().positive().catch(FIRST_PAGE).default(FIRST_PAGE),
  pageSize: z.coerce
    .number()
    .int()
    .positive()
    .catch(DEFAULT_PAGE_SIZE)
    .default(DEFAULT_PAGE_SIZE),
});
export type CourierListSearch = z.infer<typeof courierListSearchSchema>;
